import { trpc } from '@klear/ui/lib/trpc'
import type { OrderEventTimelineItem } from '@klear/order-event/order-event-timeline-tree'

export function useOrderEventTimelineTree(orderId?: number) {
  const { data, error, isLoading, refetch } = trpc.orderEvent.timelineTree.useQuery(
    { orderId: orderId ?? 0 },
    { enabled: !!orderId }
  )

  const EMPTY_TIMELINE_EVENTS: OrderEventTimelineItem[] = []

  return {
    events: data ?? EMPTY_TIMELINE_EVENTS,
    error,
    isLoading,
    refetch
  }
}

export function useOrderEventUpdates(eventId?: number, orderId?: number) {
  const enabled = !!(eventId || orderId)
  const {
    data: orderEventUpdates,
    error,
    isLoading
  } = trpc.orderEvent.listUpdateItems.useQuery({ eventId, orderId }, { enabled })

  return { orderEventUpdates: orderEventUpdates ?? [], error, isLoading }
}

export function useOrderEventRefByIdDisplay(idDisplay: string) {
  const {
    data: ref,
    error,
    isLoading
  } = trpc.orderEvent.resolveByIdDisplay.useQuery({ idDisplay }, { enabled: idDisplay.length > 0 })

  return { ref: ref ?? null, error, isLoading }
}
